import AlertBanner from "@/pages/home/components/AlertBanner";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import CareerTabs from "./components/CareerTabs";

export default function Careers() {
  return (
    <div className="min-h-screen flex flex-col">
      <AlertBanner />
      <Header />
      <main className="flex-1">
        {/* Hero heading */}
        <section className="w-full bg-background-50 pt-12 pb-6 md:pt-16 md:pb-8">
          <div className="max-w-[1100px] mx-auto px-4 md:px-6 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-800">
              Join Our{" "}
              <span className="text-primary-600 italic">Team</span>
            </h1>
          </div>
        </section>

        {/* Intro paragraph */}
        <section className="w-full bg-background-50 pb-8 md:pb-12">
          <div className="max-w-[1100px] mx-auto px-4 md:px-6">
            <p className="text-foreground-700 leading-relaxed text-base md:text-lg">
              A career with Southern Transit can be very fulfilling and beneficial. We offer several benefits to our full-time employees, and our part-time employees may have the potential to become full-time. Additionally, there may be housing opportunities at a discounted rate.
            </p>
            <p className="text-foreground-700 leading-relaxed text-base md:text-lg mt-4">
              Please click on{" "}
              <em>
                <span className="text-primary-600 font-semibold">Working for Southern Transit</span>
              </em>{" "}
              to learn more about the expectations and benefits of working for us.{" "}
              <em>
                <strong className="text-primary-600">
                  <span>Click on the Current Job Openings</span>
                </strong>
              </em>{" "}
              to see if there are any job openings now.
            </p>
          </div>
        </section>

        {/* Tabs section */}
        <section className="w-full bg-background-50 pb-16 md:pb-24">
          <div className="max-w-[1100px] mx-auto px-4 md:px-6">
            <CareerTabs />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}